module.exports = __webpack_public_path__ + "static/media/stockhausen_ganzeteile_3.77d71a89.png";